import { Field } from 'react-final-form';
import type { Descendant } from 'slate';

import { LiteRichTextEditor, LiteRichTextViewer } from '@app/components/lite-rich-text';
import type { LiteRichTextEditorProps } from '@app/components/lite-rich-text/lite-rich-text-editor/types';

export const DEFAULT_NODES = [
  {
    type: 'paragraph',
    children: [
      {
        text: '',
      },
    ],
  },
] as unknown as Descendant[];

type Props = {
  name: string;
  readOnly?: boolean;
  nodes?: Descendant[];
} & Omit<LiteRichTextEditorProps, 'nodes' | 'onChange'>;

export const LiteRichTextField = ({
  name,
  readOnly = false,
  nodes: initialNodes = DEFAULT_NODES,
  autoFocus,
  placeholder,
  className,
  elementClassNames,
}: Props) => {
  if (readOnly) {
    return (
      <LiteRichTextViewer
        nodes={initialNodes}
        className={className}
        elementClassNames={elementClassNames}
      />
    );
  }

  return (
    <Field name={name}>
      {({ input }) => (
        <LiteRichTextEditor
          nodes={initialNodes}
          autoFocus={autoFocus}
          placeholder={placeholder}
          className={className}
          elementClassNames={elementClassNames}
          onChange={(nodes) => {
            input.onChange(JSON.stringify(nodes));
          }}
        />
      )}
    </Field>
  );
};
